<template>
  <div class="container">
    <ul id="ul1" class="list-unstyled list-inline">
      <a v-for="(setting,key) in settings" v-if="setting.value!=''" :key="key" target="_blank" :href="setting.value" class="btn-floating mx-1">
        <i :class="setting.font" aria-hidden="true"> </i>
      </a>
    </ul>
    <br/>
    <div v-html="settings[0].value"></div>
    <br/>
    <vue-form :state="formstate" @submit.prevent="onSubmit">
      <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.email)">
        <label>Email</label>
        <input type="email" name="email" class="form-control" required v-model.lazy="model.email">

        <field-messages auto-label name="email" show="$touched || $submitted" class="form-control-feedback">
          <div>Success!</div>
          <div slot="required">Email is a required field</div>
          <div slot="email">Email is invalid</div>
        </field-messages>
      </validate>

      <validate auto-label class="form-group" :class="fieldClassName(formstate.message)">
        <label>Message</label>
        <textarea name="message" class="form-control" maxlength="512" v-model.lazy="model.message"></textarea>
        <small class="form-text text-muted">Enter no more than 512 characters.</small>
        <field-messages name="message" show="$touched || $submitted" class="form-control-feedback">
          <div>Success!</div>
          <div slot="maxlength">Comments must be less than 50 characters</div>
        </field-messages>
      </validate>

      <div class="py-2 text-left">
        <button class="btn btn-success" type="submit">Submit</button>
      </div>
    </vue-form>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'About',
  data () {
    return {
      formstate: {},
      model: {
        email: '',
        message: ''
      },
      settings:[
        {
          name:'',
          value:''
        }
      ]
    }
  },
  methods: {
    toFormData: function(obj){
			var form_data = new FormData();
      for ( var key in obj ) {
        form_data.append(key, obj[key]);
      } 
      return form_data;
    },
    getSettings: function(){
      var that=this;
      axios.get("http://denys.photos/admin/api.php?action=getSettings").then(function(response){
        that.settings=response.data.settings;
      });
    },
    fieldClassName: function (field) {
      if(!field) {
        return '';
      }
      if((field.$touched || field.$submitted) && field.$valid) {
        return 'has-success';
      }
      if((field.$touched || field.$submitted) && field.$invalid) {
        return 'has-danger';
      }
    },
    onSubmit: function() {
      var that=this;
      var fd = this.toFormData(this.model);
      axios.post("http://denys.photos/admin/api.php?action=sendMail",fd)
      .then(function(response){
        console.log(response);
      });
      this.model={};
    }
  },
  created: function(){
    this.getSettings();
  }

}
</script>

<style lang="scss" scoped>
$fa-font-path: "~font-awesome/fonts";
@import '~font-awesome/scss/font-awesome.scss';
.container{
  width:90%;
}
i{
  color:white;
  text-shadow: 2px 2px 15px rgba(141, 141, 141, 0.733);
}
hr{
  border-top:1px solid rgba(170, 189, 87, 0.795);
}
.required-field > label::after {
  content: '*';
  color: red;
  margin-left: 0.25rem;
}
#ul1{
  font-size:40px;
  margin:5px;
  float: auto;
}
@media (min-width: 913px) {
  input,textarea{
    width:50%;
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/about.vue